import { render, staticRenderFns } from "./navbar-drawer.vue?vue&type=template&id=7ffc52e2&scoped=true&"
import script from "./navbar-drawer.vue?vue&type=script&lang=js&"
export * from "./navbar-drawer.vue?vue&type=script&lang=js&"
import style0 from "./navbar-drawer.vue?vue&type=style&index=0&id=7ffc52e2&lang=scss&scoped=true&"
import style1 from "./navbar-drawer.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ffc52e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VTreeview } from 'vuetify/lib/components/VTreeview';
installComponents(component, {VBtn,VIcon,VImg,VList,VListItem,VListItemContent,VListItemTitle,VNavigationDrawer,VTreeview})
